import logo from "../images/CRS_logo.png";
import tagline from "../images/CRS_tagline.png";
import footer_Logo from "../images/CRS_Footer.png";
import crs_footer from "../images/CRS_footer_.png";
import crs_logo_2 from "../images/CRS_logo_.png";
import crs_og from "../images/crs_og.png";

// contact
import contactBanner from "../images/contact_us_banner.png";
import contact_candidates from "../images/contact_us_corporates.png";
import contact_corporates from "../images/contact_us_candidates.png";

// home
import Home_slide1 from "../images/Home_slide1.png";
import Home_slide2 from "../images/Home_slide2.png";
import Home_slide3 from "../images/Home_slide3.png";
import Home_slide4 from "../images/Home_slide4.png";
import Home_about from "../images/Home_about.png";
import Home_vision from "../images/Home_vision.png";
import Home_service_overseas from "../images/Home_service_overseas.jpg";
import Home_service_crypto from "../images/Home_service_crypto.jpg";
import Home_service_stocks from "../images/Home_service_stocks.jpg";
import Home_service_domestic from "../images/Home_service_domestic.jpg";
import HomeC1 from "../images/c1.png";
import HomeC2 from "../images/c2.png";
import HomeC3 from "../images/c3.png";
import HomeC4 from "../images/c4.png";
import HomeC5 from "../images/c5.png";
import HomeC6 from "../images/c6.png";
import HomeC7 from "../images/c7.jpeg";
import HomeC8 from "../images/c8.png";
import HomeC9 from "../images/c9.png";
import HomeC10 from "../images/c10.png";
import HomeC11 from "../images/c11.png";
import men1 from "../images/men 1.jpg";
import men2 from "../images/men 2.jpg";
import men3 from "../images/men 3.jpg";
import women1 from "../images/women 1.jpg";
import women2 from "../images/women 2.jpg";
import women3 from "../images/women 3.jpg";

// about
import about_Banner from "../images/About_us_.jpg";
import about_Women from "../images/About_women.png";
import g1 from "../images/Gallery/g1.jpeg";
import g2 from "../images/Gallery/g2.jpeg";
import g3 from "../images/Gallery/g3.jpeg";
import g4 from "../images/Gallery/g4.jpeg";
import g5 from "../images/Gallery/g5.jpeg";
import g6 from "../images/Gallery/g6.jpeg";
import g7 from "../images/Gallery/g7.jpeg";
import g8 from "../images/Gallery/g8.jpeg";
import g9 from "../images/Gallery/g9.jpeg";
import g10 from "../images/Gallery/g10.jpeg";
import g11 from "../images/Gallery/g11.jpeg";
import g12 from "../images/Gallery/g12.jpeg";
import g13 from "../images/Gallery/g13.jpeg";
import g14 from "../images/Gallery/g14.jpeg";
import g15 from "../images/Gallery/g15.jpeg";
import Shuaib from '../images/Shuaib_director.png';
import Adil from "../images/Aadil.png";
import Ibrahim from "../images/ibrahim.png";
import Nihad from "../images/Nihad.png";
import Ashraf from "../images/Ashraf.png";
import Usama from "../images/Usama.png";
import Adnan from "../images/Adnan.png";
import Hassan from "../images/Hassan.png";
import Masiullah from "../images/Masiullah.png";
import Ayaz from "../images/Ayaz.png";
import Alfaz from "../images/Alfaz.png";
import Thansir from "../images/Thansir.png";
import Hiba from "../images/Hiba.png";
import Waseem from "../images/Waseem.png";

// recuritment
import banner_recruit from "../images/banner_vector.png";
import recruit_vector from "../images/recruitment_vector.png";
import vect1 from "../images/recruit_1.png";
import vect2 from "../images/recruit_2.png";
import vect3 from "../images/recruit_3.png";
import vect4 from "../images/recruit_4.png";
import vect5 from "../images/recruit_5.png";
import bottom_recruit from "../images/bottom_vect.png";

// crypto
import banner_crypto from "../images/Crypto.jpg";
import crypto_1 from "../images/crypto_1.png";
import crypto_2 from "../images/crypto_2.png";
import crypto_3 from "../images/crypto_3.png";
import crypto_4 from "../images/crypto_4.png";

// stocks
import stocks_banner from "../images/stocks_banner.png";
import stock_1 from "../images/stock_1.png";
import stock_icon1 from "../images/icon1.png";
import stock_icon2 from "../images/icon2.png";
import stock_buzz from "../images/stock_buzz_2.png";

// careers
import careers from "../images/Careers.jpg";

// login
import loginImage from '../images/LoginImage.png'

// adminDetail
import dataDetail from '../images/adminDetail.gif'

const Images = {
  logoTag: logo,
  crs_logo: crs_logo_2,
  crs_og: crs_og,
  tagline: tagline,
  f_logo: footer_Logo,
  crs_f: crs_footer,
  contactBanner: contactBanner,
  contactCorporate: contact_corporates,
  contactCandidate: contact_candidates,
  slider1: Home_slide1,
  slider2: Home_slide2,
  slider3: Home_slide3,
  slider4: Home_slide4,
  home_about: Home_about,
  home_vision: Home_vision,
  home_service_overseas: Home_service_overseas,
  home_service_crypto: Home_service_crypto,
  home_service_stocks: Home_service_stocks,
  home_service_domestic: Home_service_domestic,
  c1: HomeC1,
  c2: HomeC2,
  c3: HomeC3,
  c4: HomeC4,
  c5: HomeC5,
  c6: HomeC6,
  c7: HomeC7,
  c8: HomeC8,
  c9: HomeC9,
  c10: HomeC10,
  c11: HomeC11,
  men_1: men1,
  men_2: men2,
  men_3: men3,
  women_1: women1,
  women_2: women2,
  women_3: women3,
  about_banner: about_Banner,
  about_women: about_Women,
  Shuaib: Shuaib,
  Adil: Adil,
  Ibrahim: Ibrahim,
  Nihad: Nihad,
  Ashraf: Ashraf,
  Usama: Usama,
  Adnan: Adnan,
  Hassan: Hassan,
  Masiullah: Masiullah,
  Ayaz: Ayaz,
  Alfaz: Alfaz,
  Thansir: Thansir,
  Waseem: Waseem,
  Hiba: Hiba,
  gallery_image_1: g1,
  gallery_image_2: g2,
  gallery_image_3: g3,
  gallery_image_4: g4,
  gallery_image_5: g5,
  gallery_image_6: g6,
  gallery_image_7: g7,
  gallery_image_8: g8,
  gallery_image_9: g9,
  gallery_image_10: g10,
  gallery_image_11: g11,
  gallery_image_12: g12,
  gallery_image_13: g13,
  gallery_image_14: g14,
  gallery_image_15: g15,
  banner_recruit: banner_recruit,
  recruit_vector: recruit_vector,
  vector_1: vect1,
  vector_2: vect2,
  vector_3: vect3,
  vector_4: vect4,
  vector_5: vect5,
  bottom_recruit: bottom_recruit,
  banner_crypto: banner_crypto,
  crypto_vision: crypto_1,
  crypto_invest: crypto_2,
  crypto_providing: crypto_3,
  crypto_service: crypto_4,
  stocks_banner: stocks_banner,
  stock_1: stock_1,
  stock_icon1: stock_icon1,
  stock_icon2: stock_icon2,
  stock_buzz: stock_buzz,
  careersBanner: careers,
  loginImage: loginImage,
  adminDetail: dataDetail,
};

export default Images;
